import { xl } from '../../src/main'

export function exportToExcel (orders, adminUser) {
    let date = new Date(Date.now())
    let fileName = `Export Order (${date.toLocaleString()})`
    const sheetHead = [['Identify/分单标识*', 'Shipper NO/面单号', 'Bag NO/大包号', 'Partner/合作商*', '主单/MAWB',
                        'Company or Name/公司或姓名*', 'Recv Contact Name/联系人*', 'Partner NO/合作商单号*', 'RecvCountry/目的国家*', 'RecvCity/目的城市',
                        'Recv Postal Code/邮编', 'Address Line1/收件地址1*', 'Other Address Information/其他地址信息', 'Recv Telephone/联系电话*', 'Recv E-mail/邮件地址',
                        'Res_Address/是否住宅地址', 'Shipper Name/寄件人*', 'SendCountry/发出国家*', 'SendCity/发出城市*', 'Send Postal Code/邮编',
                        'Send Contact Name/联系人', 'Send Address/发件地址*', 'Start Branch/始发网点', 'Send Telephone/联系电话*', 'Send E-mail/邮件地址',
                        'Customer/客户', 'Packing Type/包裹类型', 'Insurance/保险', 'Insurance fee/保险费', 'Certificate ID/证件号',
                        'Tax No/税号', 'Tax Rate/税率', 'PayTax Man/关税付款人', 'Special/特殊标识', 'Goods Name/货名*',
                        'HS Code/海关编码', 'Unit Price/单价', 'Actual Weight/实际重量(kg)', 'Dimensional Weight/体积重量(kg)', 'Pricing Weight/计价重量(kg)',
                        'Qty/  数量', 'Length/长(CM)', 'Width/宽(CM)', 'Height/高(CM)', 'ActualWt/总重量(kg)',
                        'Total Value/总价值', 'Currency/货币种类', 'Service/服务', 'Request1/要求1', 'Request2/要求2',
                        'Freight/运费', 'Certificate Type/证件类型', 'Pre_express/上游运单号', 'specificationType/规格型号', 'brand/品牌'
                    ]]
    
    xl.fromBlankAsync()
        .then(workbook => {
            let headCell = workbook.sheet(0).cell(1, 1)
            headCell.value(sheetHead)
            let dataCell = workbook.sheet(0).cell(2, 1)
            workbook.sheet(0).name('Exported Orders')
            

            let table = []
            for (var i = 0; i < orders.length; i++) {
                let order = orders[i]
                let items = order.packDetail.items
                for (var j = 0; j < items.length; j++) {
                    let item = items[j]
                    let row = new Array(55)
                    row[0] = i
                    row[1] = `${order.shippingNo}`
                    row[3] = adminUser ? `${order.longCode}` : ''
                    row[5] = order.shipTo.name
                    row[6] = row[5]
                    row[7] = row[1]
                    row[8] = '中国'
                    row[9] = order.shipTo.city
                    row[10] = `${order.shipTo.postal}`
                    row[11] = `${order.shipTo.province} ${order.shipTo.city} ${order.shipTo.district} ${order.shipTo.addressInfo}`
                    row[13] = `${order.shipTo.phone}`
                    row[16] = order.shipFrom.name
                    row[17] = '美国'
                    row[18] = order.shipFrom.city
                    row[19] = `${order.shipFrom.postal}`
                    row[21] = `${order.shipFrom.address1}, ${order.shipFrom.address2}, ${order.shipFrom.city}, ${order.shipFrom.postal}, United States`
                    row[23] = `${order.shipFrom.phone}`
                    row[29] = `${order.shipTo.ID}`
                    row[34] = item.name
                    row[36] = parseFloat(item.price).toFixed(2)
                    row[37] = order.packDetail.totalWeight
                    row[40] = item.qty
                    row[45] = (parseInt(item.qty) * parseFloat(item.price)).toFixed(2)
                    row[47] = 'Shipping'
                    row[50] = order.totalFee
                    row[51] = '身份证'
                    row[54] = item.name
                    table.push(row)
                }
            }
            dataCell.value(table)

            let largeColNum = [12, 22, 30, 35, 55]
            for (var k = 1; k <= 55; k++) {
                let col = workbook.sheet(0).column(k)
                if (largeColNum.includes(k)) {
                    col.width(60)
                } else {
                    col.width(20)
                }
            }

            return workbook.outputAsync()
        })
        .then(blob => {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // If IE, you must uses a different method.
                window.navigator.msSaveOrOpenBlob(blob, fileName + ".xlsx");
            } else {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = fileName + ".xlsx";
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
}